import { AiAssistantPage } from "../../aiAssistant/AiAssistantPage";
import { SupportList } from "../list/SupportList";
import { useSupportHome } from "./hooks/useSupportHome";
import styles from "./SupportHome.module.scss";

/** "/support": the AI assistant for staff when it is on, otherwise the tickets list. */
export const SupportHome = () => {
  const { view } = useSupportHome();

  if (view === "assistant") return <AiAssistantPage />;
  if (view === "tickets") return <SupportList />;

  // A light placeholder while the status loads: the page is decided in a moment, so no
  // full-screen loader.
  return (
    <div className={styles.skeleton} aria-busy="true" aria-label="Зареждане">
      <div className={styles.skeleton_header}>
        <div className={`${styles.skeleton_block} ${styles.skeleton_title}`} />
        <div className={`${styles.skeleton_block} ${styles.skeleton_button}`} />
      </div>
      <div className={styles.skeleton_body}>
        <div className={`${styles.skeleton_block} ${styles.skeleton_line}`} />
        <div className={`${styles.skeleton_block} ${styles.skeleton_line} ${styles.skeleton_line_short}`} />
      </div>
    </div>
  );
};
